export default __webpack_public_path__ + "static/media/Simio.869617ca.png";